import { ReactElement } from 'react'
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'

import { paperInputSx } from '../styles'

interface CourseFiltersProps {
  className?: string
  searchQuery: string
  categoryFilter: string
  availableCategories: string[]
  onSearchChange: (value: string) => void
  onCategoryChange: (value: string) => void
}

export default function DataGridCourseFilters({
  className,
  searchQuery,
  categoryFilter,
  availableCategories,
  onSearchChange,
  onCategoryChange,
}: CourseFiltersProps): ReactElement {
  return (
    <Box className={className}>
      <Box className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <TextField
          fullWidth
          label="Search Courses"
          placeholder="Search by name..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          slotProps={{
            input: {
              startAdornment: <SearchIcon sx={{ mr: 1 }} />,
            },
          }}
          aria-label="Search courses by name"
          sx={paperInputSx}
        />

        <FormControl fullWidth>
          <InputLabel id="category-filter-label">Category</InputLabel>
          <Select
            labelId="category-filter-label"
            value={categoryFilter}
            onChange={(e) => onCategoryChange(e.target.value)}
            label="Category"
            aria-label="Filter by category"
            sx={{ backgroundColor: 'background.paper' }}
          >
            <MenuItem value="">
              <em>All Categories</em>
            </MenuItem>
            {availableCategories.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  )
}
